import { render, staticRenderFns } from "./AppInhouseNavbar.vue?vue&type=template&id=1b8d12c4&scoped=true&"
import script from "./AppInhouseNavbar.vue?vue&type=script&lang=js&"
export * from "./AppInhouseNavbar.vue?vue&type=script&lang=js&"
import style0 from "./AppInhouseNavbar.vue?vue&type=style&index=0&id=1b8d12c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8d12c4",
  null
  
)

export default component.exports